import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, ref, computed } from "vue";
import { ACTION_URL, UPLOAD_TOKEN } from "@/config";
import Icon from "@/components/icon/index.vue";
import { Upload, Image } from "element-ui";
import { Message } from "element-ui";
import { getUploadedFileUrl, getUploadPath } from "@/common/file";

// 组件初始化参数
interface IInitParams {
  // 初始化图片地址
  imgs?: string[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    tips: { default: () => [] },
    min: null,
    max: null,
    imgFit: null
  },
  setup(__props: any, { expose }) {

const props = __props as { tips: string[], min?: number, max?: number, imgFit?: string }

const IMG_UPLOAD_SUCCESS = "success";
const IMG_UPLOAD_LOADING = "uploading";



// 上传控件
const imageUploadRef = ref<Upload>();

const uploadBaseData = ref<{
  token: string;
  key: "";
}>({
  token: UPLOAD_TOKEN,
  key: "",
});

const fileList = ref<any[]>([]);
// 图片refs
const imgRefs: {
  [key: string]: Image;
} = {};
// 所有图片的展示地址
const computedPreviewImgSrcList = computed<string[]>(() => {
  return fileList.value.map((item) => {
    if (item.url.indexOf("http") && item.response) {
      return getUploadedFileUrl(item.response.key);
    } else {
      return item.url;
    }
  });
});

// 是否渲染上传组件
const computedUploadCompVisible = computed(() => {
  if (
    typeof props.max === "number" &&
    props.max > 0 &&
    fileList.value.length >= props.max
  ) {
    return false;
  }
  return true;
});

// 触发上传
function onImageUploadChange(file: any, list: any[]) {
  fileList.value = list;
  file.url = URL.createObjectURL(file.raw);
  let reader = new FileReader();
  reader.readAsArrayBuffer(file.raw);
  reader.onload = () => {
    uploadBaseData.value.key = getUploadPath(file.name, reader.result);
    imageUploadRef.value && imageUploadRef.value.submit();
  };
}

// 上传失败
function onImageUploadError() {
  Message.error("上传失败，请重试");
}

// 设置ref
function setImgRef(index, el) {
  imgRefs[index] = el;
}

// 点击图片预览
function onImgPreview(index: number) {
  imgRefs[index] && imgRefs[index].clickHandler();
}

// 删除
function onImgDelete(file: any) {
  fileList.value = fileList.value.filter((item) => item !== file);
}

// 提供方法给外部，用于组件初始化
function init(params?: IInitParams) {
  const imgs = params?.imgs || [];
  fileList.value = imgs.map((url) => {
    return {
      status: IMG_UPLOAD_SUCCESS,
      url,
    };
  });
}

// 提供方法给外部，用于获取上传成功的照片地址
function getData() {
  if (fileList.value.some((item) => item.status !== IMG_UPLOAD_SUCCESS)) {
    Message.warning("请等待所有图片上传完毕");
    return false;
  }
  if (
    typeof props.min === "number" &&
    props.min >= 0 &&
    computedPreviewImgSrcList.value.length < props.min
  ) {
    Message.warning(`请至少上传${props.min}张图片`);
    return false;
  }
  return computedPreviewImgSrcList.value;
}

expose({
  init,
  getData,
});

return { __sfc: true,IMG_UPLOAD_SUCCESS, IMG_UPLOAD_LOADING, props, imageUploadRef, uploadBaseData, fileList, imgRefs, computedPreviewImgSrcList, computedUploadCompVisible, onImageUploadChange, onImageUploadError, setImgRef, onImgPreview, onImgDelete, init, getData, ACTION_URL, Icon }
}

})